import { entries } from 'lodash-es';
import { DropdownMenu, TextButton } from 'seagull';
import { jsx as _jsx } from "react/jsx-runtime";
const AddFilter = _ref => {
  let {
    filtersMap,
    selectedFilters,
    testId,
    onSelect
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "".concat(testId, "-add-filter-container"),
    children: /*#__PURE__*/_jsx(DropdownMenu, {
      testId: "".concat(testId, "-filter-picker"),
      hAlign: "center",
      target: /*#__PURE__*/_jsx(TextButton, {
        testId: "".concat(testId, "-add-filter-button"),
        underline: "hover",
        children: "+Add filter"
      }),
      children: entries(filtersMap).map(_ref2 => {
        let [type, label] = _ref2;
        return /*#__PURE__*/_jsx(DropdownMenu.Item, {
          skin: "primary",
          testId: "".concat(testId, "-filter-picker-").concat(type),
          disabled: selectedFilters.includes(type),
          onClick: () => onSelect(type),
          children: label
        }, type);
      })
    })
  });
};
export default AddFilter;